<app-message-header></app-message-header>
 
<div class="mat-elevation-z8">
    <mat-form-field appearance="outline" [floatLabel]="'never'">     
        <input matInput (keyup)="applyFilter($event.target.value)" matInput placeholder="Search" [(ngModel)]="search" >
        <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
           <ng-container matColumnDef="applicationName">    
                <th id="appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> APPLICATION NAME </th>
                <td mat-cell *matCellDef="let element"> 
                    <div class="textOverflow">{{element.applicationName}}
                        <!-- <a routerLink="/messages" (click) = "MyFunctionApplicationName(element)">{{element.applicationName}}</a>  -->
                    </div>
                </td>
            </ng-container> 
    
            <ng-container matColumnDef="companyName">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> RESELLER NAME</th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.companyName}}
                    </div>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="userName">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> USER NAME </th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.userName}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="connectors">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> CONNECTORS </th>
                <td mat-cell *matCellDef="let element">
                    <div class="textOverflow"> {{element.connectorList}}
                    </div>
                </td>
            </ng-container> -->

            <ng-container matColumnDef="projectStartDate">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> PROJECT START DATE</th>
                <td mat-cell *matCellDef="let element"> 
                    {{element.createdAt}}
                </td>
            </ng-container>

            <ng-container matColumnDef="projectRenewalDate">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;">LAST RENEWAL DATE </th>
                <td mat-cell *matCellDef="let element" >
                    <span *ngIf="element.lastRenewedAt !== 'undefined'">{{element.lastRenewedAt | date : 'dd-MM-yyyy'}}</span>
                    <span *ngIf="element.lastRenewedAt === 'undefined'"></span>
                </td>
            </ng-container>

            <ng-container matColumnDef="todaysMessage">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> TODAY's SENT/RECEIVE MESSAGES </th>                
                <td mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">                
                            <div id="d" *ngIf="element.count !=='' && element.count !== null && element.count !== undefined"><br/> Sx - {{element.count}} <br/><br/> Rx -  {{element.countReceviedTodaysMessage}}</div>
                            <img *ngIf="element.count ==='' || element.count === null || element.count === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count today's message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div>
                </td>                
            </ng-container>

            <ng-container matColumnDef="weeklyMessage"> 
                <th id = "appl"   mat-header-cell *matHeaderCellDef style="cursor: context-menu;">CURRENT WEEK SENT/RECEIVE MESSAGES </th> 
                <td   mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">
                            <div id="d" *ngIf="element.countweekmessage !=='' && element.countweekmessage !== null && element.countweekmessage !== undefined"><br/> Sx - {{element.countweekmessage}} <br/><br/> Rx -  {{element.countReceivedWeekMessage}}</div>
                            <img *ngIf="element.countweekmessage ==='' || element.countweekmessage === null || element.countweekmessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count week message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div> 
                </td>
            </ng-container> 

            <ng-container matColumnDef="monthlyCount">
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> CURRENT MONTH SENT/RECEIVE MESSAGES </th>            
                <td mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">
                            <div id="d" *ngIf="element.countmonthmessage !=='' && element.countmonthmessage !== null && element.countmonthmessage !== undefined"><br/> Sx - {{element.countmonthmessage}} <br/><br/> Rx -  {{element.countReceviedMonthMessage}}</div>
                            <img *ngIf="element.countmonthmessage ==='' || element.countmonthmessage === null || element.countmonthmessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count month message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div> 
                </td>
            </ng-container>
            
            <ng-container matColumnDef="yearlyCount"> 
                <th id="appl"  mat-header-cell *matHeaderCellDef style="cursor: context-menu;">CURRENT YEAR SENT/RECEIVE MESSAGES</th> 
                <td  mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">
                            <div id="d" *ngIf="element.countyearmessage !=='' && element.countyearmessage !== null && element.countyearmessage !== undefined"><br/> Sx - {{element.countyearmessage}} <br/><br/> Rx -  {{element.countReceivedYearMessage}}</div>
                            <img *ngIf="element.countyearmessage ==='' || element.countyearmessage === null || element.countyearmessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count year message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div> 
                </td>
            </ng-container>  

            <ng-container matColumnDef="totalMessage"> 
                <th id="appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;">TOTAL SENT/RECEIVE MESSAGES</th> 
                <td mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">
                            <div id="d" *ngIf="element.counttotalmessage !=='' && element.counttotalmessage !== null && element.counttotalmessage !== undefined"><br/> Sx - {{element.counttotalmessage}} <br/><br/> Rx -  {{element.countReceivedTotalMessage}}</div>
                            <img *ngIf="element.counttotalmessage ==='' || element.counttotalmessage === null || element.counttotalmessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count total message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div> 
                </td>
            </ng-container>         
    
            <ng-container matColumnDef="totalRenewedMessage"> 
                <th id="appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;">TOTAL SENT/RECEIVE MESSAGES AFTER LAST RENEWED</th> 
                <td mat-cell *matCellDef="let element">
                    <div class="spn1">
                        <div class="span2">
                            <div id="d" *ngIf="element.countrenewedtotalmessage !=='' && element.countrenewedtotalmessage !== null && element.countrenewedtotalmessage !== undefined"><br/> Sx - {{element.countrenewedtotalmessage}} <br/><br/> Rx -  {{element.countrenewedReceivedTotalMessage}}</div>
                            <img *ngIf="element.countrenewedtotalmessage ==='' || element.countrenewedtotalmessage === null || element.countrenewedtotalmessage === undefined" src="assets/images/uib-loading-500x500.gif" alt="Count total message Loader" width="25px" style="margin-top: 10px;">
                        </div>
                    </div> 
                </td>
            </ng-container>         

            <ng-container matColumnDef="percentage">            
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> TOTAL MESSAGE SENT PERCENTAGE </th>
                <td mat-cell *matCellDef="let element">{{element.sentPercentage}}</td>
            </ng-container>

            <ng-container matColumnDef="plan">            
                <th id = "appl" mat-header-cell *matHeaderCellDef style="cursor: context-menu;"> PLAN </th>
                <td mat-cell *matCellDef="let element">{{element.planName}}</td>
   <!-- {{element.billingCycle}} {{element.appSendingLimit}} -->
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>     
            <tr mat-row style="cursor: context-menu;" *matRowDef="let row; columns: displayedColumns;"></tr>   
        </table>
    
        <img  *ngIf="pageLoader" src="assets/images/uib-loading-500x500.gif"  alt="Page Loader" class="imageLoader" />
    
        <div *ngIf="recordNotFound">
            <div id="notFoundDiv" *ngIf="arr.length==0" style="color:  black; font-weight: bold">  No Records Found</div> 
        </div>
        <div *ngIf="(paginationCount>5); then thenBlock else elseBlock" ></div>
        <ng-template #thenBlock><app-pagination [collectionSize]="paginationCount" [pageSize]="10" [(page)]="page" [maxSize]="3" [disabled]="paginationDisabled" (pageChange)="pageChanged2($event)"></app-pagination></ng-template>
        <ng-template #elseBlock>
            <div *ngIf="(paginationCount<5); then tblock "></div>
        </ng-template>
        <ng-template #tblock></ng-template>
    </div>